"use client";
import React, { useEffect, useState, forwardRef } from "react";
import style from "./BannerImageText.module.scss";
import { API_BASE } from "../../../constants/config";
import IsologoTransition from "@/components/common/IsologoTransition/IsologoTransition";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";
import { useGsapBurgerTimeline } from "@/utils/useGsapBurgerTimeline";
import { useDeviceDetector } from "@/utils/useDeviceDetector";
import CommonDuckScene from "@/components/common/3D/CommonDuckScene/CommonDuckScene";

interface CarrouselResponsive {
  width: number;
  gap: number;
}

const BannerImageText = forwardRef<HTMLElement, any>(
  ({ messages, imagesCarrusel }, ref) => {
    const { isMobile } = useDeviceDetector();

    const images = imagesCarrusel;

    //States to use in the carrousel
    const [carrouselResponsive, setCarrouselResponsive] =
      useState<null | CarrouselResponsive>(null);
    const [tz, setTz] = useState<null | number>(null);
    const [containerTz, setContainerTz] = useState<null | number>(null);
    const rotationY = 360 / images.length;
    //Set the values for the carrousel
    useEffect(() => {
      const handleResize = () => {
        if (typeof window !== undefined) {
          const innerWidth = window.innerWidth;

          let result: CarrouselResponsive;

          switch (true) {
            case innerWidth < 1025:
              result = {
                width: 238,
                gap: 18.5,
              };
              setContainerTz(735);
              break;
            case innerWidth >= 1025 && innerWidth < 1201:
              result = {
                width: 363,
                gap: 28,
              };
              setContainerTz(600);
              break;
            case innerWidth >= 1201 && innerWidth < 1901:
              result = {
                width: 452,
                gap: 35,
              };
              setContainerTz(494);
              break;
            case innerWidth >= 1901:
              result = {
                width: 452,
                gap: 35,
              };
              setContainerTz(494);
              break;
          }

          setCarrouselResponsive((prev) => {
            const tz = Math.round(
              (result.width + result.gap) /
                2 /
                Math.tan(Math.PI / images.length)
            );

            setTz(tz);

            return result;
          });
        }
      };

      handleResize();

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [images.length]);
    useGsapBurgerTimeline({
      triggerClass: style.sectionContainer,
    });
    const shouldRenderCarrousel = carrouselResponsive && tz && containerTz;

    return (
      <section className={style.sectionContainer} ref={ref}>
        <IsologoTransition />
        <div className={style.imagesTextContainer}>
          <div className="container">
            <div className={style.textContainer}>
              <TitleAnimation
                messages={{
                  first_word: messages.first_words,
                  second_word: messages.second_words,
                }}
              />
              <p className={style.paragraph}>{messages.description}</p>
            </div>
          </div>

          <div className={style.carrouselContainer}>
            <div className={style.carrouselTopCircle}></div>
            <div className={style.carrouselBottomCircle}></div>
            {shouldRenderCarrousel && (
              <div className={style.carrouselWrapper}>
                <div
                  className={style.carrouselContent}
                  style={{ transform: `translateZ(${containerTz}px)` }}
                >
                  <div className={style.carrouselItemWrapper}>
                    {images.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={style.carrouselItem}
                          style={{
                            transform: `rotateY(${rotationY * index}deg) translateZ(${tz}px)`,
                          }}
                        >
                          {item ? (
                            <picture>
                              <img
                                src={`${API_BASE}${item}`}
                                alt={`Image number${index + 1}`}
                              />
                            </picture>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {isMobile && (
          <div className={style.duckScene}>
            <CommonDuckScene />
          </div>
        )}
      </section>
    );
  }
);

export default BannerImageText;

BannerImageText.displayName = "BannerImageText";
